import { StoryblokImage } from '@/components/customFields/StoryblokImage';
import type { AssetStoryblok } from '@/storyblok/wirfuersklima/types';
import type { AssetStoryblok as SbAssetStoryblok } from '@/types/component-types-sb';
import Link from 'next/link';

import classes from './Logo.module.scss';

type LogoType = {
  image: AssetStoryblok;
};

export default function Logo(props: LogoType) {
  const image = props.image as unknown as SbAssetStoryblok;
  return (
    <Link className={classes['logo']} href="https://swd-ag.de/">
      <StoryblokImage
        className={`${classes['logo__image']} campaign-logo-image`}
        image={image}
        aspectRatio={220 / 66}
        alt={image.alt}
      />
    </Link>
  );
}
